import { useGetOne } from "@mb-pro-ui/utils";
import type { Customer } from "./types";

const hubInclude = {
  group: {},
  "object-type": {},
  "customer-manager-profile": {},
} as const;

const hubFields = {
  customers: [
    "account",
    "name",
    "address",
    "passwd",
    "active",
    "temp-inactive-ts",
    "last-event-ts",
    "group",
    "object-type",
    "customer-manager-profile",
  ],
  "customer-groups": ["description"],
  "object-types": ["localized-description"],
  "customer-manager-profiles": ["settings"],
} as const;

// The datasheet relationship ids (for the shortcut counts) are requested only
// when the operator may read those models: the backend answers 403 for the
// whole request otherwise.
const datasheetFields = ["+zones", "+partitions", "+users", "+notifiable-persons"];

export function useCustomerHub(id: string, withDatasheet: boolean) {
  return useGetOne<Customer>("alarm/customers", id, {
    include: hubInclude,
    fields: {
      ...hubFields,
      customers: withDatasheet
        ? [...hubFields.customers, ...datasheetFields]
        : hubFields.customers,
    },
  });
}

// Visibility of a customer manager menu entry in the desktop customer page's
// default (non-expert) view: 0 never, 1 expert mode only, 2 always; a missing
// entry is always visible.
export function isProfileMenuVisible(
  customer: Customer | undefined,
  ...path: string[]
) {
  const profile = customer?.["customer-manager-profile"];
  const menu =
    profile && typeof profile === "object" ? profile.settings?.menu : undefined;
  return path.every((key) => (menu?.[key] ?? 2) >= 2);
}
